module.exports = __webpack_public_path__ + "img/hero.06e42276.png";